import { render } from "./TableIcons.vue?vue&type=template&id=50d07106&scoped=true"
import script from "./TableIcons.vue?vue&type=script&lang=js"
export * from "./TableIcons.vue?vue&type=script&lang=js"

import "./TableIcons.vue?vue&type=style&index=0&id=50d07106&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d07106"]])

export default __exports__